import PropTypes from 'prop-types'
import { useCallback, useState, useEffect } from 'react'
import Encoding from 'encoding-japanese';
//csvファイルエクスポート処理
export function onExportCsvFile (exportData,name) {

    {
      //BOM情報付与(utf-8 文字コードでcsvが開く情報付与)
      let bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
      const blob = new Blob([bom,exportData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download =  name+".csv"; 
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    }
}
onExportCsvFile.propTypes = {
    exportData: PropTypes.string, // 出力データ
    name: PropTypes.string, //ファイル名
}


//csvファイルエクスポート処理(sjis)
export function onExportSjisCsvFile (exportData,name) {
  {
    // SHIFT-JISにエンコード
    const sjisData = Encoding.convert(exportData, {to: 'SJIS', from: 'UNICODE', type: 'arraybuffer'});

    // 先にUint16ArrayからUint8Arrayに変換する
    const uint8Array = new Uint8Array(sjisData);
    // Blobでデータを作成
    const blob = new Blob([uint8Array], { type: 'text/csv;charset=shift-jis;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download =  name+".csv"; 
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
}
onExportSjisCsvFile.propTypes = {
  exportData: PropTypes.string, // 出力データ
  name: PropTypes.string, //ファイル名
}